module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "anchor-help-center"
  }, [_c('xi-top'), _vm._v(" "), _c('div', {
    staticClass: "center-wrapper"
  }, [_c('div', {
    staticClass: "center-menu-wrapper"
  }, [_c('router-link', {
    staticClass: "center-menu-item",
    class: {
      'top-menu-chosen': _vm.menuIndex === 0
    },
    attrs: {
      "to": {
        name: 'copyrighterAboutPlatform'
      }
    },
    nativeOn: {
      "click": function($event) {
        _vm.menuIndex = 0;
      }
    }
  }, [_c('div', {
    staticClass: "sticker"
  }), _c('i', {
    staticClass: "icon icon-20 icon-help-center-about-platform"
  }), _c('span', [_vm._v("了解平台")])]), _vm._v(" "), _c('router-link', {
    staticClass: "center-menu-item",
    class: {
      'top-menu-chosen': _vm.menuIndex === 1
    },
    attrs: {
      "to": {
        name: 'helpCenterCopyrighterSignIn'
      }
    },
    nativeOn: {
      "click": function($event) {
        _vm.menuIndex = 1;
      }
    }
  }, [_c('div', {
    staticClass: "sticker"
  }), _c('i', {
    staticClass: "icon icon-20 icon-help-center-sign-in"
  }), _c('span', [_vm._v("入驻平台")])]), _vm._v(" "), _c('router-link', {
    staticClass: "center-menu-item",
    class: {
      'top-menu-chosen': _vm.menuIndex === 2
    },
    attrs: {
      "to": {
        name: 'helpCenterCopyrightManagement'
      }
    },
    nativeOn: {
      "click": function($event) {
        _vm.menuIndex = 2;
      }
    }
  }, [_c('div', {
    staticClass: "sticker"
  }), _c('i', {
    staticClass: "icon icon-20 icon-help-center-copyright-management"
  }), _c('span', [_vm._v("版权管理")])]), _vm._v(" "), _c('router-link', {
    staticClass: "center-menu-item",
    class: {
      'top-menu-chosen': _vm.menuIndex === 3
    },
    attrs: {
      "to": {
        name: 'helpCenterTaskManagement'
      }
    },
    nativeOn: {
      "click": function($event) {
        _vm.menuIndex = 3;
      }
    }
  }, [_c('div', {
    staticClass: "sticker"
  }), _c('i', {
    staticClass: "icon icon-20 icon-help-center-task-management"
  }), _c('span', [_vm._v("任务管理")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "center-right"
  }, [_c('router-view')], 1)]), _vm._v(" "), _c('xi-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b5fc8e64!./~/vue-loader/lib/selector.js?type=template&index=0!./views/copyrighter/helpCenter/CopyrighterHelpCenter.vue
// module id = 546
// module chunks = 0